<template>
  <div
    class="m-header"
    :style="{
      height: pxOrVw(extraItem.extras('nav.model')),
      display: extraItem.extras('nav.display') == 1 ? 'block' : 'none'
    }"
  >
    <div class="header-inner">
      <a
        class="logo"
        href="javascript:;"
        :class="extraItem.extras('logo.size')"
        :style="{
          display: extraItem.extras('logo.display') == 1 ? 'block' : 'none'
        }"
      >
        <img :src="extraItem.extras('logo.src')" alt="" />
      </a>
    </div>
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
// import  service  from "../services/article";
export default {
  name: "Header",
  data() {
    return {
      extras: {}
    };
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.extras = res;
    });
  },
  components: {}
};
</script>
